// Khmer translations.
export const km = {
  // Navigation
  'nav.overview': 'ទិដ្ឋភាពទូទៅ',
  'nav.dashboard': 'ផ្ទាំងគ្រប់គ្រង',
  'nav.analytics': 'ការវិភាគ',
  'nav.reportingDashboard': 'ផ្ទាំងរបាយការណ៍',
  'nav.sales': 'ការលក់',
  'nav.salesOrders': 'ការបញ្ជាទិញលក់',
  'nav.purchase': 'ការទិញ',
  'nav.purchaseOrders': 'ការបញ្ជាទិញ',
  'nav.purchaseReview': 'កន្លែងធ្វើការពិនិត្យ',
  'nav.purchase.sprints': 'ស្ព្រិន',
  'nav.supplierOnboarding': 'ការចុះឈ្មោះអ្នកផ្គត់ផ្គង់',
  'nav.po': 'PO',
  'nav.po.sprints': 'ស្ព្រិន',
  'nav.po.newSprint': 'បង្កើតស្ព្រិន',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'គម្រោងប្រចាំសប្តាហ៍',
  'nav.scout.tagesplanung': 'គម្រោងប្រចាំថ្ងៃ',
  'nav.scout.prequal': 'ការហៅ PreQual',
  'nav.scout.missionen': 'ភារកិច្ច',
  'nav.scout.missionControl': 'ការគ្រប់គ្រងភារកិច្ច',
  'nav.scout.unternehmenssuche': 'ការស្វែងរកក្រុមហ៊ុន',
  'nav.scout.preferences': 'ចំណូលចិត្ត',
  'nav.scout.hilfe': 'ជំនួយ',
  'nav.scout.scorecard': 'កាតពិន្ទុ',
  'nav.poSprints': 'PO/ស្ព្រិន',
  'nav.wiki': 'វិគី',
  'nav.supportVisualization': 'ការធ្វើឱ្យមើលឃើញជំនួយ',
  'nav.navigationTiles': 'ក្ដារចុចរុករក',
  'nav.styleGuide': 'ការណែនាំរចនាប័ទ្ម',
  'nav.inventory': 'ស្តុក',
  'nav.items': 'ធាតុ',
  'nav.warehouse': 'ឃ្លាំង',
  'nav.picking': 'ការជ្រើសរើស',
  'nav.asn': 'ASN',
  'nav.returns': 'ការត្រឡប់',
  'nav.accounting': 'គណនេយ្យ',
  'nav.accountsReceivable': 'គណនីទទួល',
  'nav.crm': 'គ្រប់គ្រងអតិថិជន',
  'nav.leads': 'លទ្ធផលនាំមុខ',
  'nav.contacts': 'ទំនាក់ទំនង',
  'nav.ai': 'យន្តូបន្តោង',
  'nav.commandCenter': 'មជ្ឈមណ្ឌលបញ្ជា',
  'nav.workflows': 'លំហូរការងារ',
  'nav.workflowManagement': 'ការគ្រប់គ្រងលំហូរការងារ',
  'nav.projectManagement': 'ការគ្រប់គ្រងគម្រោង',
  'nav.support': 'ជំនួយ',
  'nav.tickets': 'សំបុត្រ',
  'nav.pivotTable': 'តារាង Pivot',
  'nav.learning': 'ការរៀន',
  'nav.curriculumPlanning': 'គម្រោងវគ្គសិក្សា',
  'nav.learnerDashboard': 'ផ្ទាំងរបស់អ្នករៀន',
  'nav.accessibleLearnerDashboard': 'ផ្ទាំងអ្នករៀនអាចចូលដំណើរការបាន',
  'nav.settings': 'ការកំណត់',
  'nav.general': 'ទូទៅ',
  'nav.company': 'ក្រុមហ៊ុន',
  'nav.addressManagement': 'ការគ្រប់គ្រងអាសយដ្ឋាន',
  'nav.usersRoles': 'អ្នកប្រើ និងតួនាទី',
  'nav.auditLog': 'កំណត់ហេតុឆែកឆេរ',
  'nav.integrations': 'ការរួមបញ្ចូល',
  'nav.appOverview': 'ទិដ្ឋភាពកម្មវិធី',
  'nav.appOverviewDescription': 'ចុចលើកម្មវិធីណាមួយដើម្បីរុករក ឬអូសក្ដារចុចដើម្បីរៀបចំឡើងវិញ',
  'header.help': 'ជំនួយ',
  'header.account': 'គណនី',
  'header.portalName': 'វិបផតថល CLANDA',
  'header.preferences': 'ចំណូលចិត្ត',
  'header.language': 'ភាសា',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': 'លុប',

  // Messages
  'message.success': 'ជោគជ័យ',
  'message.error': 'កំហុស',

  // Common
  'common.yes': 'យល់ព្រម',
  'common.no': 'ទេ',
  'common.cancel': 'បោះបង់',
  'common.confirm': 'បញ្ជាក់',
  'common.save': 'រក្សាទុក',
  'common.saveChanges': 'រក្សាទុកការផ្លាស់ប្តូរ',
  'common.close': 'បិទ',
  'common.reset': 'កំណត់ឡើងវិញ',
  'common.back': 'ត្រលប់',
  'common.loading': 'កំពុងផ្ទុក...',
  'common.search': 'ស្វែងរក',
  'common.search.placeholder': 'ស្វែងរក...',
  'common.filter': 'ចម្រោះ',
  'common.sort': 'តម្រៀប',
  'common.add': 'បន្ថែម',
  'common.delete': 'លុប',
  'common.edit': 'កែសម្រួល',
  'common.error': 'កំហុស',
  'common.remove': 'យកចេញ',
  'common.minutesShort': '{{value}} នាទី',
  'common.na': 'គ្មាន',
  'common.days': 'ថ្ងៃ',
  'common.status.active': 'សកម្ម',
  'common.status.paused': 'ផ្អាក',
  'common.status.stopped': 'ឈប់',
  'common.status.pending': 'រងចាំ',
  'common.status.completed': 'បានបញ្ចប់',
  'common.status.planned': 'គ្រោង',
  'common.status.inProgress': 'កំពុងដំណើរការ',
  'common.status.done': 'រួចរាល់',
  'common.apply': 'អនុវត្ត',
  'common.actions.filter': 'ចម្រោះ',
  'common.actions.export': 'នាំចេញ',
  'common.actions.search': 'ស្វែងរក',
  'common.dialog.defaultTitle': 'ដីឡូក',
  'common.all': 'ទាំងអស់',
  'common.total': 'សរុប',
  'common.pending': 'រងចាំ',
  'common.assigned': 'បានចាត់តាំង',
  'common.inProgress': 'កំពុងដំណើរការ',
  'common.completed': 'បានបញ្ចប់',
  'common.cancelled': 'បានបោះបង់',
  'common.approved': 'អនុម័ត',
  'common.rejected': 'បដិសេធ',
  'common.processing': 'កំពុងដំណើរការ',
  'common.overdue': 'ហួសកាល',
  'common.partial': 'ផ្នែក',
  'common.highPriority': 'អាទិភាពខ្ពស់',
  'common.tableView': 'ទិដ្ឋភាពតារាង',
  'common.cardView': 'ទិដ្ឋភាពកាត',
  'common.switchToTable': 'ផ្លាស់ទៅទិដ្ឋភាពតារាង',
  'common.switchToCard': 'ផ្លាស់ទៅទិដ្ឋភាពកាត',
  'common.openMenu': 'បើកម៉ឺនុយ',
  'common.details': 'ព័ត៌មានលម្អិត',
  'common.overview': 'ទិដ្ឋភាពទូទៅ',
  'common.new': 'ថ្មី',
  'common.draft': 'ពង្រាង',
  'common.shipped': 'បានដឹកជញ្ជូន',
  'common.delivered': 'បានចែកចាយ',
  'common.received': 'បានទទួល',
  'common.inTransit': 'កំពុងដឹកជញ្ជូន',
  'common.itemsPicked': 'ធាតុដែលបានជ្រើស',
  'common.totalRefund': 'ប្រាក់ដកសងសរុប',
  'common.totalPrice': 'តម្លៃសរុប',
  'common.orderSummary': 'សង្ខេបការបញ្ជាទិញ',
  'common.subtotal': 'ផ្នែករងៈ',
  'common.tax': 'ពន្ធៈ',
  'common.discount': 'បញ្ចុះតម្លៃៈ',
  'common.totalColon': 'សរុបៈ',

  // Date Range Filter (canonical component)
  'dateRange.today': 'ថ្ងៃនេះ',
  'dateRange.yesterday': 'ម្សិលមិញ',
  'dateRange.last7Days': '៧ ថ្ងៃចុងក្រោយ',
  'dateRange.last14Days': '១៤ ថ្ងៃចុងក្រោយ',
  'dateRange.last30Days': '៣០ ថ្ងៃចុងក្រោយ',
  'dateRange.thisMonth': 'ខែនេះ',
  'dateRange.custom': 'ផ្ទាល់ខ្លួន',

  // Dashboard
  'widget.vsLastPeriod': 'ធៀបនឹងរយៈពេលចុងក្រោយ',
  'table.showing': 'ការបង្ហាញ',
  'table.of': 'នៃ',
  'table.page': 'ទំព័រ',
  'table.previous': 'មុន',
  'table.next': 'បន្ទាប់',
  'table.filterGroups': 'ក្រុមតម្រង',
  'table.addFilterGroup': 'បន្ថែមក្រុមតម្រង',
  'table.filterGroup': 'ក្រុមតម្រង',
  'table.addCondition': 'បន្ថែមលក្ខខណ្ឌ',
  'table.operator': 'សញ្ញាប្រមាណវិធី',
  'table.field': 'វាល',
  'table.noFilterGroups': 'គ្មានក្រុមតម្រង។',
  'filter.operator.equals': 'ស្មើនឹង',
  'filter.operator.not_equals': 'មិនស្មើនឹង',
  'filter.operator.contains': 'មាន',
  'filter.operator.not_contains': 'មិនមាន',
  'filter.operator.starts_with': 'ចាប់ផ្តើមដោយ',
  'filter.operator.ends_with': 'បញ្ចប់ដោយ',
  'filter.operator.gt': 'ធំជាង',
  'filter.operator.lt': 'តូចជាង',
  'filter.operator.gte': 'យ៉ាងតិច',
  'filter.operator.lte': 'យ៉ាងច្រើន',
  'filter.operator.between': 'រវាង',
  'filter.operator.in': 'គឺមួយក្នុង',
  'filter.operator.not_in': 'មិនមែនមួយក្នុង',
  'filter.operator.is_set': 'បានកំណត់',
  'filter.operator.is_not_set': 'មិនបានកំណត់',
  'filter.placeholder.value': 'តម្លៃ',
  'filter.placeholder.min': 'អប្បបរមា',
  'filter.placeholder.max': 'អតិបរមា',
  'filter.placeholder.select': 'ជ្រើសរើស…',
  'filter.placeholder.selectMultiple': 'ជ្រើសរើសតម្លៃ…',
  'filter.logic.and': 'និង',
  'filter.logic.or': 'ឬ',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'ការកំណត់គណនី',

  // Consent
  'consent.title': 'ការយល់ព្រម',
  'consent.label': 'ខ្ញុំយល់ព្រមចំពោះលក្ខខណ្ឌ និងគោលការណ៍បញ្ជាទិញ',
  'consent.description': 'ខ្ញុំបានអាន និងទទួលយកលក្ខខណ្ឌ។',
  'consent.required': 'សូមយល់ព្រមចំពោះលក្ខខណ្ឌ។',
  'consent.link.terms': 'លក្ខខណ្ឌ',

  // Contacts
  'contacts.title': 'ទំនាក់ទំនង',
  'contacts.role': 'តួនាទី',
  'contacts.role.admin': 'អ្នកគ្រប់គ្រង',
  'contacts.role.billing': 'ការចាយប្រាក់',
  'contacts.role.technical': 'បច្ចេកទេស',
  'contacts.role.other': 'ផ្សេងៗ',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'សួស្តី {{name}}!',
  'learning.feed.levelInfo': 'កម្រិត {{level}} • {{xp}} XP',
  'learning.feed.offline': 'មិនភ្ជាប់',
  'learning.feed.streakLabel': 'ខ្សែថ្ងៃ',
  'learning.feed.dailyGoal': 'គោលដៅប្រចាំថ្ងៃ',
  'learning.feed.recommendedLessons': 'មេរៀនណែនាំ',
  'learning.feed.priority.high': 'ខ្ពស់',
  'learning.feed.priority.medium': 'មធ្យម',
  'learning.feed.priority.low': 'ទាប',
  'learning.feed.difficulty.easy': 'ងាយ',
  'learning.feed.difficulty.medium': 'មធ្យម',
  'learning.feed.difficulty.hard': 'ពិបាក',
  'learning.feed.aiRecommendation': 'ការណែនាំយន្តូបន្តោង',
  'learning.feed.actions.start': 'ចាប់ផ្តើម',
  'learning.feed.actions.skip': 'រំលង',
  'learning.feed.actions.reload': 'ផ្ទុកឡើងវិញ',
  'learning.feed.empty.title': 'មេរៀនទាំងអស់បានបញ្ចប់!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'អ្នកបានបញ្ចប់មេរៀនដែលមានសម្រាប់ថ្ងៃនេះ។ ត្រលប់មកវិញថ្ងៃស្អែក!',
  'learning.quiz.title': 'វិញ្ញាសា',
  'learning.quiz.questionCounter': 'សំណួរ {{current}} ក្នុង {{total}}',
  'learning.quiz.options.true': 'ពិត',
  'learning.quiz.options.false': 'មិនពិត',
  'learning.quiz.actions.next': 'បន្ទាប់',
  'learning.quiz.actions.finish': 'បញ្ចប់',
  'learning.quiz.actions.retry': 'ព្យាយាមម្តងទៀត',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'វិញ្ញាសាជោគជ័យ!',
  'learning.quiz.result.failedTitle': 'វិញ្ញាសាមិនជោគជ័យ',
  'learning.quiz.result.scoreSummary': '{{correct}} ក្នុង {{total}} ត្រឹមត្រូវ',
  'learning.quiz.result.xpEarned': '+{{xp}} XP រកបាន',
  'learning.quiz.result.answersHeading': 'ចម្លើយព័ត៌មានលម្អិត',
  'learning.quiz.result.questionLabel': 'សំណួរ {{index}}',
  'learning.quiz.result.yourAnswer': 'ចម្លើយរបស់អ្នក',
  'learning.quiz.result.correctAnswer': 'ចម្លើយត្រឹមត្រូវ',
  'learning.lessonCard.difficulty.easy': 'ងាយ',
  'learning.lessonCard.difficulty.medium': 'មធ្យម',
  'learning.lessonCard.difficulty.hard': 'ពិបាក',
  'learning.lessonCard.status.completed': 'បានបញ្ចប់',
  'learning.lessonCard.reward': 'រង្វាន់',
  'learning.lessonCard.progress': 'វឌ្ឍនភាព',
  'learning.lessonCard.selectFormat': 'ជ្រើសរើសទម្រង់',
  'learning.lessonCard.prerequisites': 'លក្ខខណ្ឌចម្បង',
  'learning.lessonCard.actions.start': 'ចាប់ផ្តើម',
  'learning.lessonCard.actions.repeat': 'ធ្វើម្តងទៀត',
  'learning.lessonCard.actions.pause': 'ផ្អាក',
  'learning.lessonCard.actions.complete': 'បញ្ចប់',
  'learning.lessonCard.actions.bookmark': 'ចងចាំ',
  'learning.lessonCard.actions.unbookmark': 'លែងចងចាំ',
  'learning.lessonCard.actions.collapse': 'បិទ',
  'learning.lessonCard.actions.expand': 'ពង្រីក',
  'learning.lessonCard.goalLabel': 'គោលដៅ',
  'learning.lessonCard.formats.video': 'មើលវីដេអូ',
  'learning.lessonCard.formats.text': 'អានអក្សរ',
  'learning.lessonCard.formats.audio': 'ស្តាប់អូឌីយ៉ូ',
  'learning.lessonCard.formats.cheatSheet': 'សន្លឹកណែនាំ',
  'learning.lessonCard.formatUnknown': 'មិនស្គាល់',
  'learning.accessible.title': 'ផ្ទាំងរៀន',
  'learning.accessible.welcome': 'សូមស្វាគមន៍ {{name}}',
  'learning.accessible.voice.start': 'សំឡេង',
  'learning.accessible.voice.stop': 'ឈប់ស្តាប់',
  'learning.accessible.voice.listening': 'កំពុងស្តាប់...',
  'learning.accessible.level': 'កម្រិត',
  'learning.accessible.xpToNext': '{{value}} XP ដល់កម្រិតបន្ទាប់',
  'learning.accessible.streak': 'ខ្សែ',
  'learning.accessible.days': '{{value}} ថ្ងៃ',
  'learning.accessible.keepItUp': 'បន្តធ្វើដូចនេះ!',
  'learning.accessible.badges': 'ផ្លាក',
  'learning.accessible.achievementsEarned': 'ការសម្រេច',
  'learning.accessible.tabs.overview': 'ទិដ្ឋភាពទូទៅ',
  'learning.accessible.tabs.lessons': 'មេរៀន',
  'learning.accessible.tabs.progress': 'វឌ្ឍនភាព',
  'learning.accessible.tabs.achievements': 'ការសម្រេច',
  'learning.accessible.recentActivity': 'សកម្មភាពថ្មីៗ',
  'learning.accessible.noRecentActivity': 'គ្មានសកម្មភាព',
  'learning.accessible.start': 'ចាប់ផ្តើម',
  'learning.accessible.learningProgress': 'វឌ្ឍនភាពរៀន',
  'learning.accessible.overallProgress': 'វឌ្ឍនភាពទូទៅ',
  'learning.accessible.achievements': 'ការសម្រេច',
  'learning.accessible.startingLesson': 'ចាប់ផ្តើមមេរៀន {{id}}',
  'learning.accessible.difficulty.beginner': 'ដំបូង',
  'learning.accessible.difficulty.intermediate': 'មធ្យម',
  'learning.accessible.difficulty.advanced': 'កម្រិតខ្ពស់',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'វឌ្ឍនភាពខ្សែ',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'មេរៀន',
  'gamification.xpToast.source.quiz': 'វិញ្ញាសា',
  'gamification.xpToast.source.streak': 'ខ្សែ',
  'gamification.xpToast.source.badge': 'ផ្លាក',
  'gamification.xpToast.source.bonus': 'រង្វាន់',
  'gamification.xpToast.levelUp.title': 'ឡើងកម្រិត!',
  'gamification.xpToast.levelUp.description': 'អ្នកឈានដល់កម្រិត {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP រកបាន',
  'gamification.xpToast.button.continue': 'បន្ត',
  'gamification.xpToast.streakMilestone.title': 'គោលខ្សែ!',
  'gamification.xpToast.streakMilestone.description': 'បានសម្រេចខ្សែ {{count}} ថ្ងៃ!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP រង្វាន់រកបាន',
  'gamification.close': 'បិទ',

  // Wissensdatenbank
  'knowledgeBase.back': 'ត្រលប់',
  'knowledgeBase.article.view': 'មើល',
  'knowledgeBase.article.views': '{{count}} ចំនួនមើល',
  'knowledgeBase.article.helpful': '{{count}} មានប្រយោជន៍',
  'knowledgeBase.article.notHelpful': '{{count}} គ្មានប្រយោជន៍',
  'knowledgeBase.article.byAuthor': 'ដោយ {{author}}',
  'knowledgeBase.header.title': 'មូលដ្ឋានចំណេះដឹង',
  'knowledgeBase.header.subtitle': 'រកចម្លើយចំពោះសំណួររបស់អ្នក',
  'knowledgeBase.actions.filter': 'ចម្រោះ',
  'knowledgeBase.actions.sort': 'តម្រៀប',
  'knowledgeBase.search.placeholder': 'ស្វែងរកក្នុងមូលដ្ឋានចំណេះដឹង...',
  'knowledgeBase.tabs.all': 'ទាំងអស់',
  'knowledgeBase.stats.popular': 'អត្ថបទពេញនិយម',
  'knowledgeBase.stats.viewsCount': '{{count}} ចំនួនមើល',
  'knowledgeBase.stats.helpful': 'អត្ថបទមានប្រយោជន៍',
  'knowledgeBase.stats.ratingsCount': '{{count}} ការវាយតម្លៃ',
  'knowledgeBase.stats.total': 'អត្ថបទសរុប',
  'knowledgeBase.stats.totalCount': '{{count}} អត្ថបទ',
  'knowledgeBase.empty.title': 'គ្មានអត្ថបទ',
  'knowledgeBase.empty.searching': 'ព្យាយាមពាក្យស្វែងរកផ្សេង ឬពិនិត្យចំណាត់ថ្នាក់។',
  'knowledgeBase.empty.default': 'គ្មានអត្ថបទក្នុងចំណាត់ថ្នាក់នេះនៅឡើយ។',
  'knowledgeBase.difficulty.beginner': 'ដំបូង',
  'knowledgeBase.difficulty.intermediate': 'មធ្យម',
  'knowledgeBase.difficulty.advanced': 'កម្រិតខ្ពស់',
  'knowledgeBase.categories.odoo-basics': 'មូលដ្ឋាន Odoo',
  'knowledgeBase.categories.crm': 'CRM និងការលក់',
  'knowledgeBase.categories.inventory': 'ស្តុក និងការទិញ',
  'knowledgeBase.categories.accounting': 'គណនេយ្យ',
  'knowledgeBase.categories.projects': 'ការគ្រប់គ្រងគម្រោង',
  'knowledgeBase.categories.troubleshooting': 'ការដោះស្រាយបញ្ហា',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'វីដេអូ',
  'curriculum.videoDescription': 'ការថតអេក្រង់ ឬវីដេអូអនុវត្ត',
  'curriculum.cheatSheet': 'សន្លឹកណែនាំ',
  'curriculum.cheatSheetDescription': 'ពុម្ភបាន កូដ QR',
  'curriculum.test': 'តេស្ត/វិញ្ញាសា',
  'curriculum.testDescription': 'ការស្ទង់ Odoo ១០ សំណួរ ៨០%',
  'curriculum.checklist': 'បញ្ជីពិនិត្យ',
  'curriculum.checklistDescription': 'ភារកិច្ច Odoo ចុចបាន',
  'curriculum.textLesson': 'អក្សរ/មេរៀន',
  'curriculum.textLessonDescription': 'មេរៀនវគ្គ Odoo',
  'curriculum.roleplay': 'លេងតួ',
  'curriculum.roleplayDescription': 'ផ្ទាល់ជាមួយអ្នកណែនាំ',
  'curriculum.practice': 'ភារកិច្ចអនុវត្ត',
  'curriculum.practiceDescription': 'ធ្វើនៅអតិថិជន',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'ទិដ្ឋភាពប្រចាំសប្តាហ៍',
  'scout.wochenplanung.previousWeek': 'សប្តាហ៍មុន',
  'scout.wochenplanung.nextWeek': 'សប្តាហ៍បន្ទាប់',
  'scout.wochenplanung.toast.appointmentAdded': 'បានបន្ថែមការណាត់ជួប',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'បានធ្វើឱ្យទាន់សម័យការណាត់ជួប',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'បានលុបការណាត់ជួប',
  'scout.wochenplanung.toast.slotUpdated': 'បានធ្វើឱ្យទាន់សម័យចន្លោះ',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'ភារកិច្ចដោះស្រាយ ឬយកចន្លោះចេញ។',

  // Planning legend
  'scout.wochenplanung.legend.completed': 'បានបញ្ចប់',
  'scout.wochenplanung.legend.planned': 'គ្រោង',
  'scout.wochenplanung.legend.partial': 'គ្រោងផ្នែក',
  'scout.wochenplanung.legend.unplanned': 'រងចាំគ្រោង',
  'scout.wochenplanung.legend.holiday': 'ថ្ងៃសម្រាក / វិស្សមកាល',

  // Missions section

  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'លុបការណាត់ជួប',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'អ្នកពិតជាចង់លុបការណាត់ជួបនេះ? សកម្មភាពនេះមិនអាចត្រឡប់វិញបាន។',
  'scout.wochenplanung.dialog.editAppointment.title': 'កែសម្រួលការណាត់ជួប',
  'scout.wochenplanung.dialog.editAppointment.description': 'អ្នកចង់អនុវត្តការផ្លាស់ប្តូរលើការណាត់ជួបនេះ?',
  'scout.wochenplanung.employee': 'អ្នករួមការងារ',
  'scout.wochenplanung.selectEmployee': 'ជ្រើសរើសអ្នករួមការងារ',
  'scout.wochenplanung.allEmployees': 'អ្នករួមការងារទាំងអស់',
  'scout.wochenplanung.error.loading': 'កំហុសការផ្ទុកគម្រោងប្រចាំសប្តាហ៍',
  'scout.wochenplanung.error.retry': 'ព្យាយាមម្តងទៀត',

  // SCOUT - Mission list empty state & actions
  'scout.missions.industries.placeholder': 'ជ្រើសរើសឧស្សាហកម្ម',
  'scout.missions.industries.search': 'ស្វែងរកឧស្សាហកម្ម...',
  'scout.missions.industries.empty': 'គ្មានឧស្សាហកម្ម',
  'scout.missions.products.placeholder': 'ជ្រើសរើសគ្រួសារផលិតផល',
  'scout.missions.products.search': 'ស្វែងរកគ្រួសារផលិតផល...',
  'scout.missions.products.empty': 'គ្មានគ្រួសារផលិតផល',
  'scout.missionControl.tabs.team': 'ទិដ្ឋភាពក្រុម',
  'scout.missionControl.teamMembers': 'សមាជិកក្រុម',
  'scout.missionControl.table.employee': 'អ្នករួមការងារ',
  'scout.missionControl.table.team': 'ក្រុម',
  'scout.missionControl.table.plzAreas': 'តំបន់កូដប្រៃសណីយ៍',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen

  // Missing keys (added from en/de; scout.wochenplanung.hours/missions already present)
  'common.saving': 'កំពុងរក្សាទុក…',
  'common.archive': 'ប័ណ្ណសារ',
  'scout.search.selectStatus': 'ជ្រើសរើសស្ថានភាព…',
  'scout.dailyPlanning.jokerAdd': 'ប្រើ joker',
  'scout.dailyPlanning.jokerTitle': 'ចំណត Joker',
  'scout.dailyPlanning.jokerUsed': 'បានប្រើ',
  'scout.dailyPlanning.jokerLimitReached': 'ឈានដល់ដែនកំណត់ចំណត joker ប្រចាំថ្ងៃ។',
  'scout.dailyPlanning.jokerCompany': 'ក្រុមហ៊ុន',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'បញ្ចូលឈ្មោះក្រុមហ៊ុន',
  'scout.dailyPlanning.jokerReason': 'មូលហេតុ',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'ហេតុអ្វីបានជាត្រូវការចំណតនេះ?',
  'scout.dailyPlanning.jokerCancel': 'បោះបង់',
  'scout.dailyPlanning.jokerSubmit': 'ប្រើ joker',
  'scout.dailyPlanning.jokerCreateError': 'មិនអាចបង្កើតចំណត joker បានទេ។',
  'missions.management.decisionMakerMet': 'ជួបអ្នកសម្រេចចិត្ត',
  'missions.management.wonAmount': 'ចំនួនឈ្នះ',

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': 'របាយការណ៍ទស្សន៍ដែលមិនទាន់បញ្ចប់',
  'scout.visitReport.compliance.description': 'អ្នកមានរបាយការណ៍ទស្សន៍ចំនួន {{count}} ដែលមិនទាន់បញ្ចប់។ សូមបំពេញវាជាមុនសិន។',
  'scout.visitReport.compliance.lockoutTitle': 'ត្រូវការរបាយការណ៍',
  'scout.visitReport.compliance.lockoutDescription': 'សូមបំពេញរបាយការណ៍ទស្សន៍ដែលមិនទាន់បញ្ចប់ទាំងអស់មុនពេលបន្ត។',
  'scout.visitReport.compliance.deferButton': 'បំពេញនៅពេលក្រោយ',
  'scout.visitReport.compliance.deferCount': 'នៅសល់ {{remaining}} ការពន្យារ',
  'scout.visitReport.compliance.noDeferrals': 'គ្មានការពន្យារនៅសល់',
  'scout.visitReport.compliance.fillReport': 'បំពេញរបាយការណ៍',
  'scout.visitReport.compliance.morningLockout': 'គម្រោងប្រចាំថ្ងៃចាក់សោររហូតដល់របាយការណ៍ដែលមិនទាន់បញ្ចប់ទាំងអស់ត្រូវបានបំពេញ។',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': 'គម្រោងវគ្គសិក្សា',
  'learning.lehrplan.subtitle': 'គ្រប់គ្រងគម្រោងវគ្គសិក្សា និងគោលដៅរៀន',
  'learning.curriculumPlanning.title': 'គម្រោងវគ្គសិក្សា',
  'learning.curriculumPlanning.subtitle': 'រៀបចំគម្រោងវគ្គសិក្សា និងភ្ជាប់មាតិការៀន',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': 'ទិដ្ឋភាពកម្មវិធី',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': 'បន្ទាប់',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys used in table/modal)
  'crm.leads': 'លទ្ធផលនាំមុខ',
  'crm.closedWon': 'ការបិទឈ្នះ',
  'crm.searchPlaceholder': 'ស្វែងរកលទ្ធផលនាំមុខ...',
  'crm.name': 'ឈ្មោះ',
  'crm.company': 'ក្រុមហ៊ុន',
  'crm.contact': 'ទំនាក់ទំនង',
  'crm.source': 'ប្រភព',
  'crm.value': 'តម្លៃ',
  'crm.lastContact': 'ទំនាក់ទំនងចុងក្រោយ',
  'crm.viewDetails': 'មើលព័ត៌មានលម្អិត',
  'crm.editLead': 'កែសម្រួលលទ្ធផលនាំមុខ',
  'crm.addNote': 'បន្ថែមកំណត់ចំណាំ',
  'crm.convertToCustomer': 'ប្តូរជាអតិថិជន',
  'crm.deleteLead': 'លុបលទ្ធផលនាំមុខ',
  'crm.leadDetails': 'ព័ត៌មានលម្អិតលទ្ធផលនាំមុខ',
  'crm.addNewLead': 'បន្ថែមលទ្ធផលនាំមុខថ្មី',
  'crm.viewLeadDetails': 'មើលព័ត៌មានលម្អិតលទ្ធផលនាំមុខ',
  'crm.createNewLead': 'បង្កើតលទ្ធផលនាំមុខថ្មី',
  'crm.fullName': 'ឈ្មោះពេញ',
  'crm.email': 'អ៉ីមែល',
  'crm.phone': 'ទូរស័ព្ទ',
  'crm.estimatedValue': 'តម្លៃប៉ាន់ស្មាន',
  'crm.notes': 'កំណត់ចំណាំ',
  'crm.status.new': 'ថ្មី',
  'crm.status.contacted': 'បានទំនាក់ទំនង',
  'crm.status.qualified': 'មានគុណភាព',
  'crm.status.proposal': 'ការផ្តល់យោបល់',
  'crm.status.negotiation': 'ការចរចា',
  'crm.status.closedWon': 'ឈ្នះ',
  'crm.status.closedLost': 'ចាញ់',
  'crm.source.website': 'គេហទំព័រ',
  'crm.source.referral': 'ការណែនាំ',
  'crm.source.tradeShow': 'ពិព័រណ៍',
  'crm.source.coldCall': 'ការហៅទូរស័ព្ទ',
  'crm.source.socialMedia': 'ប្រព័ន្ធផ្សព្វផ្សាយសង្គម',
  'crm.source.emailCampaign': 'យុទ្ធនាការអ៉ីមែល',

  // Supplier onboarding — Form

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': 'សហរដ្ឋអាមេរិក',
  'country.CA': 'កាណាដា',
  'country.MX': 'ម៉ិកស៊ិក',
  'country.GB': 'សហរាជាណាចក្រ',
  'country.DE': 'អាល្លឺម៉ង់',
  'country.FR': 'បារាំង',
  'country.other': 'ផ្សេងៗ',

  // Business type (supplier — CompanyInfoSection)
  'common.active': 'Active',
  'common.archived': 'Archived',
  'common.planned': 'Planned',
  'scout.missionen.bestandskunden.loadError': 'Failed to load existing customers',
  'scout.missionen.bestandskunden.empty': 'No existing customers found',
  'scout.missionen.bestandskunden.search': 'ស្វែងរកអតិថិជនមានស្រាប់...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} ក្នុងចំណោម {{total}} អតិថិជនមានស្រាប់',
  'scout.missionen.wunschliste.industriesTitle': 'Preferred Industries',
  'scout.missionen.wunschliste.productsTitle': 'Preferred Products',
  'scout.missionen.wunschliste.plzTitle': 'Preferred Postal Code Regions',
  'scout.missionen.wunschliste.saveButton': 'Save',
  'scout.missionen.wunschliste.saved': 'Saved',
  'scout.missionen.wunschliste.savedDesc': 'Your preferences have been saved.',
  'scout.missionen.wunschliste.saveError': 'Error',
  'scout.missionen.wunschliste.saveErrorDesc': 'Preferences could not be saved.',
  'scout.missionen.wunschliste.loadError': 'Failed to load preferences',
  'scout.tagesplanung.title': 'Tagesplanung',
  'scout.tagesplanung.addressUnknown': 'Address unknown',
  'scout.tagesplanung.routeMapLabel': 'Route Map',
  'scout.tagesplanung.routePlanning': 'Route Planning',
  'scout.tagesplanung.traffic': 'Traffic',
  'scout.tagesplanung.deferNotPossible': 'Deferral not possible',
  'scout.tagesplanung.deferMaxReached': 'Maximum number of deferrals for today reached (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'This lead has already been deferred today.',
  'scout.tagesplanung.dayCannotClose': 'Day cannot be closed',
  'scout.tagesplanung.outstandingReports': 'There are {{count}} outstanding visit reports. Please complete all before closing the day.',
  'scout.tagesplanung.andMore': '... and {{count}} more',
  'scout.tagesplanung.tabs.planning': 'Daily plan',
  'scout.tagesplanung.tasks.tabLabel': 'Tasks',
  'scout.tagesplanung.tasks.empty': 'No tasks',
  'scout.tagesplanung.tasks.loading': 'Loading tasks',
  'scout.tagesplanung.tasks.error': 'Could not load tasks',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Status',
  'scout.tagesplanung.tasks.filterStatusTodo': 'To do',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'In progress',
  'scout.tagesplanung.tasks.filterStatusDone': 'Done',
  'scout.tagesplanung.tasks.priorityLabel': 'Priority',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Due',
  'scout.tagesplanung.tasks.dueNone': 'No due date',
  'scout.lead.neukunde': 'New customer — niche product as door opener',
  'scout.lead.bestandskunde': 'Existing customer',
  'scout.metrics.besuche': 'Visits',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Orders',
  'scout.metrics.umsatz': 'Revenue',
  'scout.metrics.demoRate': 'Demo Rate',
  'scout.composition.title': 'Mission Composition',
  'scout.composition.minBestandskunden': 'Min. Existing Customers',
  'scout.composition.minQualifiziert': 'Min. Qualified Leads',
  'scout.composition.maxKaltbesuche': 'Max. Cold Visits',
  'scout.dailyPlanning.addAppointment': 'Add appointment',
  'scout.dailyPlanning.appointments': 'Appointments',
  'scout.dailyPlanning.noAppointmentsPlanned': 'No appointments planned for this day',
  'scout.dailyPlanning.leadsByPriority': 'Leads (by priority)',
  'scout.dailyPlanning.noLeadsPlanned': 'No leads planned for this day',
  'scout.dailyPlanning.skipLead': 'Skip lead',
  'scout.dailyPlanning.skipLeadConfirmation': 'Do you really want to skip this lead? It will be moved to the next day.',
  'scout.dailyPlanning.skip': 'Skip',
  'scout.dailyPlanning.removeLead': 'Remove lead',
  'scout.dailyPlanning.removeLeadConfirmation': 'Do you really want to remove this lead? It will be completely removed from rotation.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Select a mission to view leads',
  'scout.dailyPlanning.selectDate': 'Select date',
  'scout.dailyPlanning.nextDay': 'Next day',
  'scout.dailyPlanning.closeDay': 'Close day',
  'scout.dailyPlanning.reopenDay': 'Reopen day',
  'scout.dailyPlanning.noAcceptedLeads': 'No accepted leads for this day.',
  'scout.dailyPlanning.statusSkipped': 'Skipped',
  'scout.dailyPlanning.selectAll': 'Select all',
  'scout.dailyPlanning.selectAllLeads': 'Select all leads',
  'scout.dailyPlanning.noSuggestions': 'No suggestions.',
  'scout.dailyPlanning.previousDay': 'Previous day',
  'scout.dailyPlanning.calendarWeek': 'Calendar week {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visit',
  'scout.dailyPlanning.details': 'Details',
  'scout.dailyPlanning.missionsLoading': 'Loading missions…',
  'scout.dailyPlanning.leadsLoading': 'Loading leads…',
  'scout.dailyPlanning.noLeadsFound': 'No leads found',
  'scout.dailyPlanning.moreLeads': 'ទៀត',
  'scout.dailyPlanning.dailyList': 'Daily List',
  'scout.dailyPlanning.unknown': 'Unknown',
  'scout.dailyPlanning.suggestedLeads': 'Suggested Leads',
  'scout.dailyPlanning.error': 'Error: {{error}}',
  'scout.dailyPlanning.help': 'Help',
  'scout.dailyPlanning.bulkActions': 'Bulk actions',
  'scout.dailyPlanning.actionsCount': 'Actions ({{count}})',
  'scout.dailyPlanning.accept': 'Accept',
  'scout.dailyPlanning.reject': 'Reject',
  'scout.dailyPlanning.selectLead': 'Select lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Open details for {{name}}',
  'scout.dailyPlanning.score': 'Score: {{score}}',
  'scout.dailyPlanning.loading': 'Loading daily planning',
  'scout.scorecard.selectHeatmapMetric': 'Select heatmap metric',
  'scout.scorecard.orders': 'Orders',
  'scout.scorecard.annualTargetOrders': 'Annual target orders',
  'scout.scorecard.comingSoon': 'Coming soon',
  'scout.scorecard.kpiOverview': 'KPI overview, activities and top industries',
  'scout.scorecard.activityByDay': 'Activity by day',
  'scout.scorecard.title': 'Scorecard',
  'scout.scorecard.period.tag': 'Day',
  'scout.scorecard.period.woche': 'Week',
  'scout.scorecard.period.monat': 'Month',
  'scout.scorecard.period.jahr': 'Year',
  'scout.scorecard.kpiTilesHeading': 'KPI tiles',
  'scout.scorecard.topBranchenProdukteHeading': 'Top industries and top products',
  'scout.scorecard.soll': 'Target',
  'scout.scorecard.forecast': 'Forecast',
  'scout.scorecard.gapToGo': 'Gap-to-Go',
  'scout.scorecard.csvExport': 'CSV Export',
  'scout.scorecard.pdfExport': 'PDF Export',
  'scout.scorecard.table.date': 'Date',
  'scout.scorecard.table.visits': 'Visits',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Orders',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Net revenue',
  'scout.scorecard.table.total': 'Total',
  'scout.scorecard.topBranchen': 'Top industries',
  'scout.scorecard.topProdukte': 'Top products',
  'scout.scorecard.table.industry': 'Industry',
  'scout.scorecard.table.quantity': 'Quantity (units)',
  'scout.scorecard.table.revenue': 'Revenue (€)',
  'scout.scorecard.table.product': 'Product',
  'scout.scorecard.table.salesVolume': 'Sales volume',
  'scout.scorecard.table.customers': 'Customers',
  'scout.scorecard.kpi.visits': 'Visits',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Orders',
  'scout.scorecard.kpi.netRevenue': 'Net revenue',
  'scout.scorecard.kpi.gebinde60l': '60L units',
  'scout.scorecard.kpi.gebinde25l': '25L units',
  'scout.scorecard.kpi.gebinde10l': '10L units',
  'scout.scorecard.emptyTitle': 'No data',
  'scout.scorecard.emptyDescription': 'No KPI data available for the selected period.',
  'scout.scorecard.missionPerformanceTitle': 'Mission Performance',
  'scout.scorecard.missionMissionsCompleted': 'Missions completed',
  'scout.scorecard.missionConversionRate': 'Conversion rate',
  'scout.scorecard.missionTerritoryCoverage': 'Territory coverage',
  'scout.scorecard.viewMissionDetails': 'View Details',
  'scout.scorecard.adjustTargets': 'Adjust targets',
  'scout.scorecard.annualTarget': 'Annual target',
  'scout.scorecard.annualTargetVisits': 'Annual target visits',
  'scout.scorecard.annualTargetDemos': 'Annual target demos',
  'scout.scorecard.annualTargetNetRevenue': 'Net revenue (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Annual target net revenue in EUR',
  'scout.scorecard.monthlyOverrides': 'Monthly overrides',
  'scout.scorecard.table.month': 'Month',
  'scout.scorecard.table.reason': 'Reason',
  'scout.scorecard.derivedTargets': 'Derived targets',
  'scout.scorecard.dailyTargetLabel': 'Daily target: {{count}} visits',
  'scout.scorecard.weeklyTargetLabel': 'Weekly target: {{count}} visits',
  'scout.scorecard.save': 'Save',
  'scout.scorecard.heatmap.visits': 'Visits',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Revenue',
  'scout.scorecard.heatmap.low': 'Low',
  'scout.scorecard.heatmap.high': 'High',
  'scout.scorecard.heatmap.scaleA11y': 'Color scale from low to high',
  'scout.scorecard.heatmap.loading': 'Loading map…',
  'scout.missionControl.teamOverview': 'Your team and their PLZ areas',
  'scout.missionControl.jokerLimitPerDay': 'Joker limit / day',
  'scout.missionControl.jokerLimitUpdated': 'Joker limit has been updated.',
  'scout.missionControl.jokerLimitSaveFailed': 'Failed to save joker limit.',
  'scout.missionControl.selectTeam': 'Select team',
  'scout.missionControl.none': 'None',
  'scout.missionControl.addPlzAreaFor': 'Add PLZ area for',
  'scout.missionControl.addPlzArea': 'Add PLZ area',
  'scout.missionControl.noTeamMembersFound': 'No team members found.',
  'scout.missionControl.orders': 'Orders',
  'scout.missionControl.resetSettings': 'Reset settings',
  'scout.missionControl.saveSettings': 'Save settings',
  'scout.missionControl.territorySaturation': 'Territory saturation (PLZ)',
  'scout.missionControl.day': 'Day',
  'scout.missionControl.selectDay': 'Select day',
  'scout.missionControl.week': 'Week',
  'scout.missionControl.selectWeek': 'Select week',
  'scout.missionControl.month': 'Month',
  'scout.missionControl.selectMonth': 'Select month',
  'scout.missionControl.planFulfillment': 'Plan fulfillment',
  'scout.missionControl.plzPrefixPlaceholder': 'PLZ prefix (e.g. 70)',
  'scout.missionControl.plzPrefix': 'PLZ prefix',
  'scout.missionControl.addPlzToWhitelist': 'Add PLZ prefix to whitelist',
  'scout.missionControl.addPlzToGreylist': 'Add PLZ prefix to grey list',
  'scout.missionControl.addPlzToYellowlist': 'Add PLZ prefix to yellow list',
  'scout.missionControl.addNewTeamMember': 'Add new team member',
  'scout.missionControl.lastModified': 'Last modified',
  'scout.missionControl.outsideAreaRules': 'Outside area rules',
  'scout.missionControl.outsidePlzPolicy': 'Policy for PLZ outside lists',
  'scout.missionControl.enableOutsideWarning': 'Enable warning for PLZ outside area',
  'scout.missionControl.requireOutsideApproval': 'Require approval for PLZ outside area',
  'scout.missionControl.rejectOutsidePlz': 'Reject PLZ outside area',
  'scout.missionControl.checkPlz': 'Check PLZ or PLZ prefix',
  'scout.missionControl.check': 'Check',
  'scout.missionControl.error': 'Error',
  'scout.missionControl.success': 'Success',
  'scout.missionControl.userProfileNotFound': 'User profile not found',
  'scout.missionControl.plzAreasUpdated': 'PLZ areas updated',
  'scout.missionControl.plzAreasSaveFailed': 'PLZ areas could not be saved',
  'scout.missionControl.repConfig.title': 'Rep Configuration',
  'scout.missionControl.repConfig.repName': 'Name / Email',
  'scout.missionControl.repConfig.industries': 'Industries',
  'scout.missionControl.repConfig.products': 'Products',
  'scout.missionControl.repConfig.plz': 'PLZ',
  'scout.missionControl.repConfig.loadError': 'Failed to load rep configuration',
  'scout.missionControl.repConfig.saveError': 'Save failed',
  'scout.missionControl.repConfig.savedTitle': 'Saved',
  'scout.missionControl.repConfig.savedDesc': 'Rep configuration updated',
  'scout.missionControl.jokerConfig.title': 'Joker Limit Per Day',
  'scout.missionControl.jokerConfig.description': 'Maximum number of joker uses per rep per day.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max per day',
  'scout.missionControl.jokerConfig.loadError': 'Failed to load joker configuration',
  'scout.missionControl.jokerConfig.saveError': 'Save failed',
  'scout.missionControl.jokerConfig.savedTitle': 'Saved',
  'scout.missionControl.jokerConfig.savedDesc': 'Joker limit updated',
  'scout.missionControl.diagnostics.demoRate': 'Demo Rate',
  'scout.missionControl.diagnostics.visitDepth': 'Visit Depth',
  'scout.unternehmenssuche.selectAllResults': 'Select all search results',
  'scout.unternehmenssuche.openingHours': 'OPENING HOURS',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporarily closed',
  'scout.unternehmenssuche.startSearch': 'Start search',
  'scout.unternehmenssuche.searchRunning': 'Searching...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Please adjust your search criteria or try again.',
  'scout.unternehmenssuche.selectCompanyType': 'Select company type',
  'scout.unternehmenssuche.openingHoursTime': 'Opening hours time',
  'scout.unternehmenssuche.noTimeNeeded': 'No time specification needed',
  'scout.unternehmenssuche.addConditions': 'Add conditions to refine your search',
  'scout.unternehmenssuche.addCondition': 'Add condition',
  'scout.unternehmenssuche.addGroup': 'Add group',
  'scout.unternehmenssuche.savedSearchName': 'Saved search name',
  'scout.unternehmenssuche.saveCurrentSearch': 'Save current search',
  'scout.unternehmenssuche.savedSearches': 'Saved searches',
  'scout.unternehmenssuche.noSavedSearches': 'No saved searches available.',
  'scout.unternehmenssuche.keywordPlaceholder': 'e.g. Restaurant, Bar, Bakery',
  'scout.unternehmenssuche.addWaypoint': 'Add waypoint',
  'scout.unternehmenssuche.locationPlaceholder': 'e.g. Munich Marienplatz',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Show or hide additional filters',
  'scout.unternehmenssuche.additionalFilters': 'Additional filters',
  'scout.unternehmenssuche.saveSearchAsFile': 'Save search as file',
  'scout.unternehmenssuche.loadSearchFromFile': 'Load search from file',
  'scout.unternehmenssuche.checkSearchTerms': 'Please check your search terms or try again.',
  'search.overlay.hint': 'Type and press Enter or click Search.',
  'search.overlay.placeholder': 'Search (/) for resources, docs, and more',
  'search.overlay.searchLabel': 'Search',
  'search.overlay.noResults': 'No results for "{{query}}"',
  'search.overlay.tryDifferent': 'Try different keywords or check your spelling.',
  'search.overlay.topResults': 'Top results',
  'search.overlay.documentation': 'Documentation · ',
  'scout.unternehmenssuche.locationRadius': 'Location + Radius',
  'scout.unternehmenssuche.routeCorridor': 'Route + Corridor',
  'scout.unternehmenssuche.withoutLocation': 'Without location',
  'scout.scorecard.heatmapTitle': 'Activity heatmap (PLZ-2)',
  'scout.preferences.defaultRegionLabel': 'Default region',
  'scout.preferences.selectRegionPlaceholder': 'Select region',
  'scout.preferences.defaultStatusLabel': 'Default status',
  'scout.preferences.selectDefaultStatus': 'Select default status',
  'scout.preferences.statusDraft': 'Draft',
  'scout.preferences.statusActive': 'Active',
  'scout.preferences.statusCompleted': 'Completed',
  'scout.preferences.statusArchived': 'Archived',
  'scout.preferences.saving': 'Saving...',
  'scout.preferences.plzPrefixes': 'PLZ prefixes for missions',
  'scout.preferences.plzPrefixesPlaceholder': 'Enter PLZ prefixes separated by commas (e.g. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Max. route length (km)',
  'scout.preferences.maxRouteLengthDescription': 'Maximum route length in kilometers',
  'scout.preferences.autoGenerateMissions': 'Auto-generate missions (nightly automation)',
  'scout.preferences.autoGenerateDescription': 'When enabled, missions will be automatically generated based on your settings.',
  'scout.preferences.defaultAssigneeLabel': 'Default responsible person',
  'scout.preferences.defaultAssigneePlaceholder': 'Enter default responsible person',
  'scout.preferences.defaultAssigneeAria': 'Default responsible person',
  'scout.preferences.defaultLeadCountLabel': 'Default number of leads',
  'scout.preferences.defaultLeadCountAria': 'Default number of leads',
  'scout.preferences.defaultDurationLabel': 'Default duration (days)',
  'scout.preferences.defaultDurationAria': 'Default duration in days',
  'scout.preferences.autoAssignLabel': 'Automatically assign missions to default responsible person',
  'scout.preferences.productFamiliesLabel': 'Product families',
  'scout.preferences.industryCodesLabel': 'Industries',
  'scout.preferences.keywordsLabel': 'Keywords',
  'scout.preferences.keywordsPlaceholder': 'e.g. concrete, screed',
  'scout.preferences.minLeadsLabel': 'Min. leads per mission',
  'scout.preferences.minLeadsAria': 'Minimum leads per mission',
  'scout.preferences.maxLeadsLabel': 'Max. leads per mission',
  'scout.preferences.maxLeadsAria': 'Maximum leads per mission',
  'scout.preferences.dailyQuotaLabel': 'Number of missions per day',
  'scout.preferences.dailyQuotaAria': 'Maximum missions per day',
  'scout.preferences.dailyQuotaHelper': 'Maximum number of auto-generated missions per day (1-3)',
  'scout.dailyPlanning.inField': 'In the field',
  'scout.dailyPlanning.completed': 'Completed',
  'scout.dailyPlanning.openDay': 'Open day',
  'scout.dailyPlanning.dayMarkedCompleted': 'This day is marked as completed.',
  'scout.dailyPlanning.statusVisited': 'Visited',
  'scout.dailyPlanning.statusPlanned': 'Planned',
  'scout.dailyPlanning.statusCompleted': 'Completed',
  'scout.createMission.title': 'Create new mission',
  'scout.createMission.description': 'Choose name, filters and assignments',
  'scout.createMission.nameLabel': 'Name',
  'scout.createMission.nameRequired': 'Name is required',
  'scout.createMission.namePlaceholder': 'e.g. Stuttgart North — Refrigeration',
  'scout.createMission.nameAria': 'Mission name',
  'scout.createMission.regionLabel': 'Region (optional)',
  'scout.createMission.regionPlaceholder': 'e.g. PLZ 70xxx',
  'scout.createMission.regionAria': 'Region or PLZ',
  'scout.createMission.ownerLabel': 'Owner',
  'scout.createMission.ownerPlaceholder': 'Email address',
  'scout.createMission.ownerAria': 'Owner email address',
  'scout.createMission.themeLabel': 'Theme (optional)',
  'scout.createMission.themePlaceholder': 'e.g. Refrigeration',
  'scout.createMission.themeAria': 'Mission theme',
  'scout.createMission.productLabel': 'Product (optional)',
  'scout.createMission.productPlaceholder': 'e.g. K-2000',
  'scout.createMission.productAria': 'Product',
  'scout.createMission.cancel': 'Cancel',
  'scout.createMission.save': 'Save',
  'scout.createMission.saveBusy': 'Saving…',
  'scout.createMission.cancelAria': 'Cancel mission creation',
  'scout.createMission.saveAria': 'Save mission',
  'scout.createMission.saveBusyAria': 'Mission is being saved',
  'settings.description': 'Manage your application preferences and customization options',
  'settings.typography.title': 'Typography',
  'settings.typography.description': 'Adjust text size and density for readability or compactness',
  'settings.typography.scale.title': 'Text size',
  'settings.typography.scale.description': 'Standard matches Masterslight baseline; Comfort increases size for long sessions',
  'settings.typography.scale.ariaLabel': 'Text size preset',
  'settings.typography.scale.compact': 'Compact',
  'settings.typography.scale.standard': 'Standard',
  'settings.typography.scale.comfort': 'Comfort',
  'settings.tabs.appearance': 'Appearance',
  'settings.tabs.account': 'Account',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.security': 'Security',
  'settings.language.title': 'Language Preferences',
  'settings.language.description': 'Choose your preferred language for the application interface',
  'settings.language.interfaceLanguage': 'Interface Language',
  'settings.language.interfaceLanguageDesc': 'Select the language for menus, buttons, and interface elements',
  'settings.theme.title': 'Color Theme',
  'settings.theme.description': 'Customize the appearance and colors of your interface',
  'settings.theme.predefinedThemes': 'Want to choose from 10 predefined themes?',
  'settings.theme.goToThemeSettings': 'Go to Theme Settings',
  'settings.themeSettings.title': 'Theme Settings',
  'settings.themeSettings.description': 'Customize the appearance of your application with predefined themes',
  'settings.themeSettings.themeDetails': 'Theme Details',
  'settings.themeSettings.themeId': 'Theme ID:',
  'settings.themeSettings.colorScheme': 'Color Scheme:',
  'settings.account.profile.title': 'Profile Information',
  'settings.account.profile.description': 'Update your personal information and account details',
  'settings.account.profile.name': 'Name',
  'settings.account.profile.email': 'Email',
  'settings.account.profile.role': 'Role',
  'settings.account.profile.department': 'Department',
  'settings.account.profile.editProfile': 'Edit Profile',
  'settings.account.data.title': 'Data Management',
  'settings.account.data.description': 'Manage your data synchronization and backup preferences',
  'settings.account.data.cloudSync': 'Cloud Sync',
  'settings.account.data.cloudSyncEnabled': 'Your preferences are synced to the cloud',
  'settings.account.data.cloudSyncDisabled': 'Cloud sync is disabled (feature flag)',
  'settings.account.data.syncNow': 'Sync Now',
  'settings.notifications.title': 'Notification Preferences',
  'settings.notifications.description': 'Configure how you receive notifications',
  'settings.notifications.email.title': 'Email Notifications',
  'settings.notifications.email.description': 'Receive notifications via email',
  'settings.notifications.push.title': 'Push Notifications',
  'settings.notifications.push.description': 'Receive push notifications in browser',
  'settings.notifications.system.title': 'System Alerts',
  'settings.notifications.system.description': 'Important system notifications',
  'settings.notifications.configure': 'Configure',
  'settings.security.title': 'Security Settings',
  'settings.security.description': 'Manage your account security and privacy settings',
  'settings.security.password.title': 'Password',
  'settings.security.password.lastChanged': 'Last changed 30 days ago',
  'settings.security.password.change': 'Change',
  'settings.security.twoFactor.title': 'Two-Factor Authentication',
  'settings.security.twoFactor.description': 'Add an extra layer of security',
  'settings.security.twoFactor.enable': 'Enable',
  'settings.security.sessions.title': 'Session Management',
  'settings.security.sessions.description': 'Manage active sessions',
  'settings.security.sessions.view': 'View Sessions',
  'settings.company.title': 'Company Settings',
  'settings.company.description': 'Manage your company information and preferences',
  'settings.company.edit': 'Edit Company',
  'settings.company.saveChanges': 'Save Changes',
  'settings.company.cancel': 'Cancel',
  'settings.company.tabs.general': 'General',
  'settings.company.tabs.contact': 'Contact',
  'settings.company.tabs.billing': 'Billing',
  'settings.company.tabs.branding': 'Branding',
  'settings.company.general.companyInfo': 'Company Information',
  'settings.company.general.companyName': 'Company Name',
  'settings.company.general.legalName': 'Legal Name',
  'settings.company.general.taxId': 'Tax ID',
  'settings.company.general.registrationNumber': 'Registration Number',
  'settings.company.general.industry': 'Industry',
  'settings.company.general.foundedYear': 'Founded Year',
  'settings.company.general.employees': 'Number of Employees',
  'settings.company.general.industry.technology': 'Technology',
  'settings.company.general.industry.manufacturing': 'Manufacturing',
  'settings.company.general.industry.retail': 'Retail',
  'settings.company.general.industry.healthcare': 'Healthcare',
  'settings.company.general.industry.finance': 'Finance',
  'settings.company.general.industry.other': 'Other',
  'settings.company.address.title': 'Address Information',
  'settings.company.address.street': 'Street Address',
  'settings.company.address.city': 'City',
  'settings.company.address.state': 'State',
  'settings.company.address.zipCode': 'ZIP Code',
  'settings.company.address.country': 'Country',
  'settings.company.address.country.us': 'United States',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'United Kingdom',
  'settings.company.address.country.de': 'Germany',
  'settings.company.address.country.fr': 'France',
  'settings.company.address.country.other': 'Other',
  'settings.company.contact.title': 'Contact Information',
  'settings.company.contact.phone': 'Phone Number',
  'settings.company.contact.email': 'Email Address',
  'settings.company.contact.website': 'Website',
  'settings.company.contact.supportEmail': 'Support Email',
  'settings.company.billing.title': 'Billing Settings',
  'settings.company.billing.currency': 'Currency',
  'settings.company.billing.taxRate': 'Tax Rate (%)',
  'settings.company.billing.paymentTerms': 'Payment Terms',
  'settings.company.billing.billingCycle': 'Billing Cycle',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Due on Receipt',
  'settings.company.billing.cycle.monthly': 'Monthly',
  'settings.company.billing.cycle.quarterly': 'Quarterly',
  'settings.company.billing.cycle.annually': 'Annually',
  'settings.company.billing.cycle.custom': 'Custom',
  'settings.company.billing.summary.title': 'Billing Summary',
  'settings.company.billing.summary.currentPlan': 'Current Plan',
  'settings.company.billing.summary.monthlyCost': 'Monthly Cost',
  'settings.company.billing.summary.nextBillingDate': 'Next Billing Date',
  'settings.company.billing.summary.paymentMethod': 'Payment Method',
  'settings.company.billing.summary.status': 'Status',
  'settings.company.billing.summary.active': 'Active',
  'settings.company.branding.title': 'Branding & Appearance',
  'settings.company.branding.logo': 'Company Logo',
  'settings.company.branding.uploadLogo': 'Upload Logo',
  'settings.company.branding.logoHint': 'PNG, JPG up to 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Upload Favicon',
  'settings.company.branding.faviconHint': 'ICO, PNG up to 1MB',
  'settings.company.branding.primaryColor': 'Primary Color',
  'settings.company.branding.secondaryColor': 'Secondary Color',
  'settings.usersRoles.stats.totalUsers': 'Total Users',
  'settings.usersRoles.stats.activeUsers': 'active users',
  'settings.usersRoles.stats.totalRoles': 'Total Roles',
  'settings.usersRoles.stats.roleConfigurations': 'Role configurations',
  'settings.userManagement.title': 'User Management',
  'settings.userManagement.description': 'Manage users, roles, and system settings',
  'settings.userManagement.addUser': 'Add User',
  'settings.userManagement.editUser': 'Edit User',
  'settings.userManagement.createNewUser': 'Create New User',
  'settings.userManagement.updateUserInfo': 'Update user information',
  'settings.userManagement.addNewUser': 'Add a new user to the system',
  'settings.userManagement.tabs.users': 'Users',
  'settings.userManagement.tabs.appAccess': 'App Access',
  'settings.userManagement.tabs.roles': 'Roles',
  'settings.userManagement.toast.userCreated': 'User created successfully',
  'settings.userManagement.toast.userUpdated': 'User updated successfully',
  'settings.userManagement.toast.userDeleted': 'User deleted successfully',
  'settings.userManagement.toast.roleCreated': 'Role created successfully',
  'settings.userManagement.toast.roleUpdated': 'Role updated successfully',
  'settings.userManagement.toast.roleDeleted': 'Role deleted successfully',
  'settings.userManagement.toast.error': 'Failed to create user',
  'settings.userManagement.toast.errorUpdate': 'Failed to update user',
  'settings.userManagement.toast.errorDelete': 'Failed to delete user',
  'settings.userManagement.toast.errorRoleCreate': 'Failed to create role',
  'settings.userManagement.toast.errorRoleUpdate': 'Failed to update role',
  'settings.userManagement.toast.errorRoleDelete': 'Failed to delete role',
  'settings.integrations.settings.security.enabled': 'Enabled',
  'settings.integrations.settings.security.disabled': 'Disabled',
  'crm.contacts.title': 'CRM Contacts',
  'crm.contacts.description': 'Manage customer and supplier contacts with address information',
  'crm.contacts.add': 'Add Contact',
  'crm.contacts.edit': 'Edit Contact',
  'crm.contacts.delete': 'Delete Contact',
  'crm.contacts.view360': '360° View',
  'crm.contacts.unassigned': 'Unassigned',
  'crm.contacts.type.customer': 'Customer',
  'crm.contacts.type.supplier': 'Supplier',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Prospect',
  'crm.contacts.status.active': 'Active',
  'crm.contacts.status.inactive': 'Inactive',
  'crm.contacts.status.suspended': 'Suspended',
  'crm.contacts.validation.companyRequired': 'Company name is required',
  'crm.contacts.validation.streetRequired': 'Street address is required',
  'crm.contacts.validation.postalRequired': 'Postal code is required',
  'crm.contacts.validation.cityRequired': 'City is required',
  'crm.contacts.validation.countryRequired': 'Country is required',
  'crm.contacts.validation.nameRequired': 'Contact name is required',
  'crm.contacts.validation.emailInvalid': 'Invalid email address',
  'crm.contacts.validation.phoneRequired': 'Phone number is required',
  'crm.contacts.validation.salesPersonRequired': 'Sales person is required',
  'crm.contacts.validation.ordererNameRequired': 'Orderer name is required',
  'crm.contacts.validation.roleRequired': 'Role is required',
  'crm.contacts.validation.hoursRequired': 'Hours are required',
  'crm.openMenu': 'Open menu',
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Manage sales leads and track conversion',
  'crm.leads.add': 'Add Lead',
  'crm.leads.edit': 'Edit Lead',
  'crm.leads.delete': 'Delete Lead',
  'crm.leads.status.new': 'New',
  'crm.leads.status.contacted': 'Contacted',
  'crm.leads.status.qualified': 'Qualified',
  'crm.leads.status.proposal': 'Proposal',
  'crm.leads.status.negotiation': 'Negotiation',
  'crm.leads.status.closedWon': 'Closed Won',
  'crm.leads.status.closedLost': 'Closed Lost',
  'crm.leads.source.website': 'Website',
  'crm.leads.source.referral': 'Referral',
  'crm.leads.source.email': 'Email',
  'crm.leads.source.phone': 'Phone',
  'crm.leads.source.social': 'Social Media',
  'crm.leads.source.other': 'Other',
  'crm.leads.value': 'Value',
  'crm.leads.lastContact': 'Last Contact',
  'crm.leads.notes': 'Notes',
  'crm.leads.search': 'Search leads...',
  'crm.leads.filterByStatus': 'Filter by status',
  'crm.leads.filterBySource': 'Filter by source',
  'crm.leads.totalLeads': 'Total Leads',
  'crm.leads.pipelineValue': 'Pipeline Value',
  'crm.leads.qualifiedLeads': 'Qualified Leads',
  'visitReport.title': 'Visit Report',
  'visitReport.createTitle': 'Create Visit Report',
  'visitReport.titleFor': 'Visit Report for {{name}}',
  'visitReport.visitType': 'Visit Type',
  'visitReport.coldVisit': 'Cold Visit',
  'visitReport.appointment': 'Appointment',
  'visitReport.salesOutcome': 'Sales Outcome',
  'visitReport.noContact': 'No Contact',
  'visitReport.conversation': 'Conversation',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Order',
  'visitReport.orderValue': 'Order Value (EUR)',
  'visitReport.nextStep': 'Next Step',
  'visitReport.callback': 'Callback',
  'visitReport.sendOffer': 'Send Offer',
  'visitReport.revisit': 'Revisit',
  'visitReport.completed': 'Completed',
  'visitReport.appointmentWindow': 'Appointment Window (optional)',
  'visitReport.from': 'From',
  'visitReport.to': 'To',
  'visitReport.contactName': 'Contact Name',
  'visitReport.enterName': 'Enter Name',
  'visitReport.roleFunction': 'Role / Function',
  'visitReport.enterRole': 'Enter Role',
  'visitReport.isDecisionMaker': 'Is Decision Maker?',
  'visitReport.decisionMakerName': 'Decision Maker Name',
  'visitReport.decisionMakerRole': 'Decision Maker Role',
  'visitReport.email': 'Email (optional)',
  'visitReport.phone': 'Phone (optional)',
  'visitReport.notes': 'Notes (optional)',
  'visitReport.additionalInfo': 'Additional information...',
  'visitReport.productsDiscussed': 'Products Discussed?',
  'visitReport.annualDemand': 'Annual Demand',
  'visitReport.select': 'Select',
  'visitReport.interest': 'Interest',
  'visitReport.interestHigh': 'high',
  'visitReport.interestMedium': 'medium',
  'visitReport.interestLow': 'low',
  'visitReport.modelFeedback': 'Was the system recommendation appropriate?',
  'visitReport.feedbackYes': 'Yes',
  'visitReport.feedbackPartially': 'Partially',
  'visitReport.feedbackNo': 'No',
  'visitReport.feedbackNotSeen': 'Not Seen',
  'visitReport.branchCorrect': 'Branch correct? (optional)',
  'visitReport.selectBranch': 'Select Branch',
  'visitReport.branchConstruction': 'Construction',
  'visitReport.branchIndustry': 'Industry',
  'visitReport.branchTrade': 'Trade',
  'visitReport.branchService': 'Service',
  'visitReport.noInterestReason': 'Reason for No Interest',
  'visitReport.wrongProduct': 'Wrong Product',
  'visitReport.wrongTiming': 'Wrong Timing',
  'visitReport.existingSupplier': 'Existing Supplier',
  'visitReport.noBudget': 'No Budget',
  'visitReport.noNeed': 'No Need',
  'visitReport.decisionMakerNotReached': 'Decision Maker Not Reached',
  'visitReport.additionalRemarks': 'Additional Remarks (optional)',
  'visitReport.error': 'Error',
  'visitReport.validationError': 'Please select visit type and sales outcome.',
  'visitReport.deferralNotPossible': 'Deferral Not Possible',
  'visitReport.maxDeferralReached': 'You have already deferred the last report. Please complete it.',
  'visitReport.reportDeferred': 'Report Deferred',
  'visitReport.deferralMessage': 'You can complete the report later.',
  'visitReport.reportCreated': 'Visit Report Created',
  'visitReport.reportSaved': 'Visit report saved.',
  'visitReport.reportSavedFor': 'Visit report for {{name}} saved.',
  'visitReport.reportError': 'Visit report could not be created.',
  'visitReport.stepOf': 'Step {{current}} of {{total}}',
  'visitReport.back': 'Back',
  'visitReport.cancel': 'Cancel',
  'visitReport.inAHurry': 'I am in a hurry',
  'visitReport.next': 'Next',
  'visitReport.saving': 'Saving...',
  'visitReport.finishVisit': 'Finish Visit',
  'visitReport.contactNotes': 'Additional information about the contact...',
  'visitReport.callingQueue.prompt': 'Should an AI appointment call be prepared for this lead?',
  'visitReport.callingQueue.yes': 'Yes, add to queue',
  'visitReport.callingQueue.no': 'No',
  'visitReport.callingQueue.toast': 'Lead added to calling queue',
  'modals.assignMissionModal.close': 'Close',
  'modals.assignMissionModal.searchPlaceholder': 'Search (title/industry)',
  'modals.assignMissionModal.searchAriaLabel': 'Search',
  'modals.missionQuickViewModal.description': 'Quick overview of the mission. Open the mission page for details.',
  'modals.missionQuickViewModal.close': 'Close',
  'modals.missionQuickViewModal.openDetails': 'Open details',
  'modals.missionQuickViewModal.openDetailsAria': 'Open mission detail',
  'modals.leadDetailModal.close': 'Close',
  'modals.leadDetailModal.whoIsThis': 'Who is this?',
  'modals.leadDetailModal.whatDoTheyNeed': 'What do they need?',
  'modals.leadDetailModal.whatDoISay': 'What do I say?',
  'modals.leadDetailModal.moreProducts': 'More products',
  'modals.regionDetailsModal.description': 'Overview of mission details. This view is read-only.',
  'modals.regionDetailsModal.edit': 'Edit',
  'modals.regionDetailsModal.close': 'Close',
  'modals.editRegionModal.close': 'Close',
  'modals.editRegionModal.description': 'Edit time and note for the mission. Status is read-only.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Status is read-only.',
  'modals.splitAssignmentDialog.actionLabel': 'Select action',
  'modals.splitAssignmentDialog.confirmButton': 'Confirm',
  'modals.addAppointmentModal.companyAriaLabel': 'Select or enter company / lead',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmed',
  'modals.rejectLead.title': 'Reject Lead',
  'modals.rejectLead.closeAria': 'Close dialog',
  'modals.rejectLead.description': 'Select at least one rejection reason.',
  'modals.rejectLead.reasonsLabel': 'Rejection reasons',
  'modals.rejectLead.reasonsError': 'Please select at least one reason.',
  'modals.rejectLead.otherReasonLabel': 'Other reason',
  'modals.rejectLead.otherReasonPlaceholder': 'Please describe the reason...',
  'modals.rejectLead.otherReasonAria': 'Other rejection reason',
  'modals.rejectLead.otherReasonError': 'Please enter a reason.',
  'modals.rejectLead.cancel': 'Cancel',
  'modals.rejectLead.confirm': 'Reject ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Out of business',
  'modals.rejectLead.reason.temporarilyClosed': 'Temporarily closed',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Known and unsuitable',
  'modals.rejectLead.reason.noInterest': 'No interest',
  'modals.rejectLead.reason.wrongContact': 'Wrong contact',
  'modals.rejectLead.reason.other': 'Other',
  'app.routes.loadingSettings': 'Loading settings...',
  'companySearch.filters.companySize': 'Company Size',
  'curriculum.modules.pillar': 'Pillar',
  'curriculum.modules.selectLevel': 'Select level',
  'curriculum.modules.selectPillar': 'Select pillar',
  'curriculum.modules.selectPillarOption': 'Select pillar',
  'learning.lessonViewer.audioNotSupported': 'Your browser does not support the audio element.',
  'learning.lessonViewer.complete': 'Complete',
  'learning.lessonViewer.formatNotSupported': 'Format not supported',
  'learning.lessonViewer.videoNotSupported': 'Your browser does not support the video element.',
  'learning.moduleEditor.pillar': 'Pillar',
  'learning.moduleEditor.pillarLabel': 'Pillar',
  'learning.tabs.availableLessons': 'Available Lessons',
  'learning.tabs.availableQuizzes': 'Available Quizzes',
  'missionControl.totalLeads': 'Total Leads',
  'missionControl.completedLeads': 'Completed Leads',
  'missions.management.demoPerformed': 'Demo performed',
  'missions.management.demoPerformedLabel': 'Demo performed',
  'missions.management.kpiDescription': 'Decision maker met, demo performed, revenue',
  'missions.management.moreActions': 'Show more actions for mission',
  'missions.management.publish': 'Publish',
  'missions.management.searchPlaceholder': 'Search (Name/Region/Topic/Product)',
  'mobile.layout.closeMenu': 'Close menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'No offline content available',
  'mobile.layout.offlinePerformance': 'For better offline performance',
  'navigation.tileCard.openActions': 'Open tile actions',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thuringia',
  'scout.sprints.ciEstimate': 'CI Runtime Estimate',
  'scout.sprints.estimatedMinutes': 'Estimated Minutes',
  'styleGuide.charts.noStatusColors': 'Charts must not use status colors',
  'styleGuide.confirmation': 'Confirmation',
  'styleGuide.description': 'Description',
  'styleGuide.statusSemantics.success': 'Success = Completed / OK',
  'tickets.list.filterPriority': 'Filter priority',
  'ui.calendar.nextMonth': 'Next Month',
  'ui.errorBoundary.returnToDashboard': 'Return to Dashboard',
  'ui.impersonation.selectImpersonation': 'Select impersonation',
  'ui.impersonation.selectUser': 'Select user:',
  'ui.routingPreview.openAppleMaps': 'Open in Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Open in Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} Stops · {{distance}} km · {{time}} min (estimated)',
  'ui.routingPreview.title': 'Route Preview',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Additional Notes',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Add appointment',
  'scout.help.selectArticle': 'Select an article on the left or use search to open a help article.',
  'survey.contact.name': 'ឈ្មោះ',
  'survey.contact.namePlaceholder': 'បញ្ចូលឈ្មោះ',
  'survey.contact.function': 'មុខតំណែង / តួនាទី',
  'survey.contact.functionPlaceholder': 'បញ្ចូលមុខតំណែង',
  'survey.contact.email': 'អ៊ីមែល',
  'survey.contact.emailPlaceholder': 'បញ្ចូលអាសយដ្ឋានអ៊ីមែល',
  'survey.contact.phone': 'ទូរស័ព្ទ',
  'survey.contact.phonePlaceholder': 'បញ្ចូលលេខទូរស័ព្ទ',
  'survey.contact.isDecisionMaker': 'ជាអ្នកសម្រេចចិត្ត?',
}
